// Port of api/fuel/app/classes/insights/size/trends.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import GameArtist from 'offline/model/game/artist'
import GameCategory from 'offline/model/game/category'
import GameDesigner from 'offline/model/game/designer'
import GameFamily from 'offline/model/game/family'
import GameMechanic from 'offline/model/game/mechanic'
import GamePublisher from 'offline/model/game/publisher'
import Artist from 'offline/model/artist'
import Category from 'offline/model/category'
import Designer from 'offline/model/designer'
import Family from 'offline/model/family'
import Mechanic from 'offline/model/mechanic'
import Publisher from 'offline/model/publisher'

function groupedIds(rows, groupField, valueField) {
	var grouped = {}
	for (var i = 0; i < rows.length; i++) {
		var key = parseInt(rows[i][groupField], 10)
		var value = parseInt(rows[i][valueField], 10)
		if (!key || !value) continue
		if (!grouped[key]) grouped[key] = []
		grouped[key].push(value)
	}
	return grouped
}

function resolveName(type, id, lookup) {
	if (type === 'weight') return 'Weight of ' + id
	if (type === 'year') return 'Released within ' + id + ' years'
	if (type === 'supportcount') return 'Supports ' + id + ' players'
	if (type === 'bestcount') return 'Best at ' + id + ' players'
	if (type === 'recommendedcount') return 'Recommended at ' + id + ' players'
	if (type === 'durationmin') return 'Duration >= ' + id + ' minutes'
	if (type === 'durationmax') return 'Duration <= ' + id + ' minutes'
	return lookup && lookup[id] ? lookup[id] : ''
}

export default Segment.extend({
	name: 'trends',
	types: [Constants.TYPE_USER],
	enabled: false,
	insight: false,
	detail: false,
	run: function(type, owner, userIndex, detail, filter, vars) {
		if (!owner.get_count_collection()) return {}

		var trends = []
		var logs = Util.queryFast(
			'SELECT g.game_id AS g, c.game_version_id AS v, l.log_date AS d, l.log_context AS c,' +
			' g.game_players_min AS pn, g.game_players_max AS px, g.game_players_community AS pc,' +
			' g.game_time_min AS dn, g.game_time_min AS dx, g.game_weight_avg AS w, g.game_published AS y, g.game_rank AS r' +
			' FROM (log_user_collection l LEFT JOIN collection c ON c.game_id = l.game_id AND c.user_id = l.user_id), game g' +
			' WHERE l.log_context IN(' + Util.in([Constants.LOG_CONTEXT_ADDED]) + ')' +
			' AND g.game_type = 1 AND l.game_id = g.game_id AND l.user_id = ' + owner.get_id() +
			' ORDER BY l.log_date ASC'
		)

		if (!logs.length) return { trends: trends }

		var rawData = []
		var gameIndex = Array.from(new Set(logs.map(function(log) { return parseInt(log.g, 10) }).filter(Boolean)))
		var versionIndex = Array.from(new Set(logs.map(function(log) { return parseInt(log.v, 10) }).filter(function(value) { return value !== 0 })))

		var artists = groupedIds(GameArtist.collection({ where: [['game_id', 'in', gameIndex]] }).map(function(model) { return model.rawData() }), 'game_id', 'artist_id')
		var categories = groupedIds(GameCategory.collection({ where: [['game_id', 'in', gameIndex]] }).map(function(model) { return model.rawData() }), 'game_id', 'category_id')
		var designers = groupedIds(GameDesigner.collection({ where: [['game_id', 'in', gameIndex]] }).map(function(model) { return model.rawData() }), 'game_id', 'designer_id')
		var families = groupedIds(GameFamily.collection({ where: [['game_id', 'in', gameIndex]] }).map(function(model) { return model.rawData() }), 'game_id', 'family_id')
		var mechanics = groupedIds(GameMechanic.collection({ where: [['game_id', 'in', gameIndex]] }).map(function(model) { return model.rawData() }), 'game_id', 'mechanic_id')

		var publisherGameRows = GamePublisher.collection({
			where: [
				['game_id', 'in', gameIndex],
				['game_version_id', '=', 0],
				['game_publisher_primary', '=', 1]
			]
		}).map(function(model) { return model.rawData() })
		var publisherVersionRows = versionIndex.length ? GamePublisher.collection({
			where: [
				['game_version_id', 'in', versionIndex]
			]
		}).map(function(model) { return model.rawData() }) : []
		var publishers = {
			games: groupedIds(publisherGameRows, 'game_id', 'publisher_id'),
			versions: groupedIds(publisherVersionRows, 'game_version_id', 'publisher_id')
		}

		for (var i = 0; i < logs.length; i++) {
			var log = logs[i]
			var counts = {}
			try {
				counts = JSON.parse(log.pc || '{}') || {}
			} catch (e) {
				counts = {}
			}
			var recommended = []
			var best = []
			var countKeys = Object.keys(counts)
			for (var ck = 0; ck < countKeys.length; ck++) {
				var countKey = countKeys[ck]
				if (counts[countKey].b > counts[countKey].r + counts[countKey].n) best.push(parseInt(countKey, 10))
				if (counts[countKey].b + counts[countKey].r > counts[countKey].n) recommended.push(parseInt(countKey, 10))
			}

			var supportCounts = []
			for (var p = parseInt(log.pn, 10) || 0; p <= (parseInt(log.px, 10) || 0); p++) supportCounts.push(p)
			var versionId = parseInt(log.v, 10) || 0
			var gameId = parseInt(log.g, 10)

			rawData.push({
				context: parseInt(log.c, 10) || 0,
				game: gameId,
				date: Util.date_start(parseInt(log.d, 10) || 0),
				mechanic: mechanics[gameId] || [],
				category: categories[gameId] || [],
				family: families[gameId] || [],
				designer: designers[gameId] || [],
				publisher: versionId ? (publishers.versions[versionId] || []) : (publishers.games[gameId] || []),
				artist: artists[gameId] || [],
				supportcount: supportCounts,
				recommendedcount: recommended,
				bestcount: best,
				durationmin: [Math.ceil((parseInt(log.dn, 10) || 0) / 30) * 30],
				durationmax: [Math.ceil((parseInt(log.dx, 10) || 0) / 30) * 30],
				weight: [Math.round((parseFloat(log.w) || 0) * 2) / 2],
				year: [Math.floor(parseInt(Util.date('Y', parseInt(log.d, 10) || 0), 10) - (parseInt(log.y, 10) || 0))]
			})
		}

		var maxBars = 10
		var trendBars = Math.floor(rawData.length / maxBars)
		var trendSize
		var trendFirstSize
		if (trendBars > maxBars) {
			trendSize = Math.floor(rawData.length / maxBars)
			trendFirstSize = rawData.length - (trendSize * maxBars)
			trendBars = maxBars
		} else if (trendBars > 0) {
			trendSize = Math.floor(rawData.length / trendBars)
			trendFirstSize = rawData.length % trendSize
		} else {
			trendBars = 1
			trendSize = rawData.length
			trendFirstSize = 0
		}

		var index = 0
		var rawTrends = {}
		var trackedTypes = ['mechanic', 'category', 'family', 'artist', 'designer', 'publisher', 'weight', 'year', 'bestcount', 'durationmin', 'durationmax']

		for (var b = 1; b <= trendBars; b++) {
			var barSize = (b === 1) ? trendSize + trendFirstSize : trendSize
			for (var ri = index; ri < index + barSize; ri++) {
				for (var tt = 0; tt < trackedTypes.length; tt++) {
					var typeKey = trackedTypes[tt]
					var values = rawData[ri][typeKey]
					for (var vi = 0; vi < values.length; vi++) {
						var id = values[vi]
						if (!rawTrends[typeKey]) rawTrends[typeKey] = {}
						if (!rawTrends[typeKey][id]) {
							rawTrends[typeKey][id] = []
							for (var ab = 1; ab <= trendBars; ab++) {
								rawTrends[typeKey][id][ab - 1] = { total: 0, current: 0, rolling: 0 }
							}
						}

						if (rawData[ri].context === Constants.LOG_CONTEXT_ADDED) {
							rawTrends[typeKey][id][b - 1].total++
							rawTrends[typeKey][id][b - 1].current++
						} else {
							rawTrends[typeKey][id][b - 1].total--
							rawTrends[typeKey][id][b - 1].current--
						}

						for (var fb = b; fb <= trendBars; fb++) {
							if (fb === 1) rawTrends[typeKey][id][fb - 1].rolling = rawTrends[typeKey][id][fb - 1].current
							else if (fb === 2) rawTrends[typeKey][id][fb - 1].rolling = (rawTrends[typeKey][id][fb - 1].current + rawTrends[typeKey][id][fb - 2].current) / 2
							else rawTrends[typeKey][id][fb - 1].rolling = (rawTrends[typeKey][id][fb - 1].current + rawTrends[typeKey][id][fb - 2].current + rawTrends[typeKey][id][fb - 3].current) / 3
							rawTrends[typeKey][id][fb - 1].total = rawTrends[typeKey][id][b - 1].total
							rawTrends[typeKey][id][fb - 1].rolling = Math.round((100 / barSize) * rawTrends[typeKey][id][fb - 1].rolling)
						}
					}
				}
			}
			index += barSize
		}

		var artistNames = {}
		var categoryNames = {}
		var designerNames = {}
		var familyNames = {}
		var mechanicNames = {}
		var publisherNames = {}

		var artistModels = Artist.collection({ where: [['artist_id', 'in', Util.merge(Object.keys(rawTrends.artist || {}).map(function(id) { return { ids: id } }), 'ids')]] })
		for (var ai = 0; ai < artistModels.length; ai++) artistNames[artistModels[ai].get_id()] = artistModels[ai].get_name()
		var categoryModels = Category.collection({ where: [['category_id', 'in', Util.merge(Object.keys(rawTrends.category || {}).map(function(id) { return { ids: id } }), 'ids')]] })
		for (var ca = 0; ca < categoryModels.length; ca++) categoryNames[categoryModels[ca].get_id()] = categoryModels[ca].get_name()
		var designerModels = Designer.collection({ where: [['designer_id', 'in', Util.merge(Object.keys(rawTrends.designer || {}).map(function(id) { return { ids: id } }), 'ids')]] })
		for (var de = 0; de < designerModels.length; de++) designerNames[designerModels[de].get_id()] = designerModels[de].get_name()
		var familyModels = Family.collection({ where: [['family_id', 'in', Util.merge(Object.keys(rawTrends.family || {}).map(function(id) { return { ids: id } }), 'ids')]] })
		for (var fa = 0; fa < familyModels.length; fa++) familyNames[familyModels[fa].get_id()] = familyModels[fa].get_name()
		var mechanicModels = Mechanic.collection({ where: [['mechanic_id', 'in', Util.merge(Object.keys(rawTrends.mechanic || {}).map(function(id) { return { ids: id } }), 'ids')]] })
		for (var me = 0; me < mechanicModels.length; me++) mechanicNames[mechanicModels[me].get_id()] = mechanicModels[me].get_name()
		var publisherModels = Publisher.collection({ where: [['publisher_id', 'in', Util.merge(Object.keys(rawTrends.publisher || {}).map(function(id) { return { ids: id } }), 'ids')]] })
		for (var pu = 0; pu < publisherModels.length; pu++) publisherNames[publisherModels[pu].get_id()] = publisherModels[pu].get_name()

		var lookups = {
			artist: artistNames,
			category: categoryNames,
			designer: designerNames,
			family: familyNames,
			mechanic: mechanicNames,
			publisher: publisherNames
		}

		var typeKeys = Object.keys(rawTrends)
		for (var tk = 0; tk < typeKeys.length; tk++) {
			var trendType = typeKeys[tk]
			var ids = Object.keys(rawTrends[trendType])
			for (var idIndex = 0; idIndex < ids.length; idIndex++) {
				var trendId = ids[idIndex]
				var rollings = rawTrends[trendType][trendId].map(function(item) { return item.rolling })
				var maxRolling = Math.max.apply(null, rollings)
				var minRolling = Math.min.apply(null, rollings)
				if (maxRolling - minRolling >= 25 && maxRolling >= 25) {
					trends.push({
						name: resolveName(trendType, trendId, lookups[trendType]),
						type: trendType,
						id: trendId,
						trend: rollings
					})
				}
			}
		}

		for (var sh = trends.length - 1; sh > 0; sh--) {
			var swap = Math.floor(Math.random() * (sh + 1))
			var temp = trends[sh]
			trends[sh] = trends[swap]
			trends[swap] = temp
		}

		trends = trends.slice(0, 15)

		return {
			trends: trends
		}
	}
})
